import React,{Component} from 'react';
import './validator.css'
 export default class ValidCase extends Component{
    render(){
        if(!this.props.valid && !this.props.hide){
            return(
                <p className='message-item'>
                    {this.props.message}
                </p>
            )
        }else{
            return null;
        }
        
    }
 }